import { render, staticRenderFns } from "./employee.vue?vue&type=template&id=ebd51cdc&scoped=true"
import script from "./employee.vue?vue&type=script&lang=js"
export * from "./employee.vue?vue&type=script&lang=js"
import style0 from "./employee.vue?vue&type=style&index=0&id=ebd51cdc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebd51cdc",
  null
  
)

export default component.exports